import { useEffect } from 'react';
import useICallGenerator from 'app/contacts/utils/useICallGenerator';

const InstantCallContactAction = ({ payload, onComplete }) => {
    const iCall = useICallGenerator();
    useEffect(() => {
        iCall.handleInstantCall(payload);
        setTimeout(() => {
            onComplete && onComplete(payload);
        }, 5000);
        // eslint-disable-next-line
    }, []);
};

export default InstantCallContactAction;
